import { render, staticRenderFns } from "./SamsPattern.vue?vue&type=template&id=bd8628a2"
import script from "./SamsPattern.vue?vue&type=script&lang=js"
export * from "./SamsPattern.vue?vue&type=script&lang=js"
import style0 from "./SamsPattern.vue?vue&type=style&index=0&id=bd8628a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports